(function () {
    angular.module('components.carousel')
        .component('carouselV2', {
            require: {
                parentCarousel: '?^^carouselV2',
                carouselSync: '?^carouselSync',
                paginator: '?^bmgPagination'
            },
            bindings: {
                slides: '<',
                slideCount: '<?',
                spacing: '<?',
                auto: '<?',
                autoInterval: '<?',
                disableDrag: '<?',
                startSlide: '<?',
                route: '@?',
                routeTarget: '@?',
                animationPrep: '&?',
                animation: '&?',
                preAnimation: '&?',
                animationSnap: '&?',
                onInit: '&?',
                onChange: '&?',
                onSlideChange: '&?',
                onEdge: '&?'
            },
            controller: CarouselController
        });
    var ids = 1;
    var parentCarousel;
    CarouselController.$inject = ['$scope', '$element', '$attrs', '$transitions', '$stateParams', '$state', '$window', '$timeout', '$q', '$templateRequest', '$compile', 'utility'];
    function CarouselController($scope, $element, $attrs, $transitions, $stateParams, $state, $window, $timeout, $q, $templateRequest, $compile, utility) {
        var ctrl = this;
        var win, width, slides;
        var slideContent = '';
        ctrl.id = ids++;
        ctrl.$onInit = function () {
            if (!ctrl.autoInterval) {
                ctrl.autoInterval = 8000;
            }
            if (!ctrl.animationPrep) {
                ctrl.animationPrep = function (data) {
                    return data.data;
                };
            }
            if (!ctrl.animation) {
                ctrl.animation = function (data) {
                    return {
                        x: data.carousel.width() * index
                    };
                };
            }
            if (!ctrl.spacing) {
                ctrl.spacing = 0;
            }
            ctrl.$slideCount = utility.getResponsiveValue(ctrl.slideCount);
            if (ctrl.$slideCount === undefined) {
                ctrl.$slideCount = 1;
            }
            if (!ctrl.animationSnap) {
                ctrl.animationSnap = function (data) {
                    var index = -Math.round(data.offset / ctrl.width);
                    return {
                        index: index,
                        position: -Math.max(0, Math.min(ctrl.slides.length - ctrl.$slideCount, index - Math.floor(ctrl.$slideCount / 2))) * ctrl.width
                    };
                };
            }
            ctrl.index = ctrl.startSlide || 0;
            ctrl.renderIndex = ctrl.index;
            slideContent = angular.element('<div>');
            slideContent.html($element.html());
            ctrl.$$dragDisabled = slideContent.find('carousel').length > 0 || (ctrl.$slideCount !== undefined && ctrl.slides && ctrl.slides.length <= ctrl.$slideCount);
            if (ctrl.carouselSync !== null) {
                ctrl.carouselIndex = ctrl.carouselSync.registerCarousel(ctrl);
            }
            if (ctrl.slides !== undefined) { //prevents issue caused by slider compilation
                ctrl.$$registerTransitions();
            }
            
            if (ctrl.onInit) {
                ctrl.onInit({
                    ctrl: ctrl
                });
            }
        };

        ctrl.$onChanges = function (changes) {
            if (ctrl.targetParams === undefined) {
                ctrl.targetParams = $stateParams;
                ctrl.$$registerTransitions();
            }
            if (!isNaN(ctrl.targetParams[ctrl.routeTarget])) {
                ctrl.$$updateIndex(parseInt(ctrl.targetParams[ctrl.routeTarget]), false);
                ctrl.positionDraggable(false);
            }
            if (changes.startSlide) {
                ctrl.goToSlide(changes.startSlide.currentValue, false);
            }
            $timeout(function () {
                ctrl.$$updateSlideReferences(true);
                if (ctrl.onChange) {
                    ctrl.onChange({
                        changes: changes
                    });
                }
            });
            if (changes.slides && !changes.slides.previousValue && ctrl.auto) {
                ctrl.$$nextAutoStep();
            }
        };

        ctrl.$postLink = function () {
            $templateRequest('/angular/components/carousel/carouselV2.html', true).then(function (markup) {
                if ($scope.$destroyed)
                    return;
                var html = angular.element(markup);
                ctrl.$$dragger = html.find('.drag-tracker')[0];
                ctrl.$$slider = html.find('.slides').find('>div');
                html.find('.slide').html(slideContent.find('>slide').html().replace('carousel-repeat', 'ng-repeat'));
                html.find('.controls').html(slideContent.find('>controls').html());
                $element.html(html);
                $compile($element.contents())($scope);

                if (!ctrl.$$dragDisabled) {
                    TweenLite.set(ctrl.$$dragger, {
                        position: 'absolute',
                        x: 0
                    });
                    ctrl.$$draggable = Draggable.create(ctrl.$$dragger, {
                        type: 'x',
                        trigger: $element,
                        lockAxis: true,
                        edgeResistance: .65,
                        dragResistance: .1,
                        dragClickables: true,
                        throwResistance: .1,
                        maxDuration: 3,
                        throwProps: true,
                        zIndexBoost: true,
                        snap: function (endValue) {
                            var snapData = ctrl.animationSnap({ offset: endValue, data: ctrl.animationData });
                            ctrl.$$updateIndex(snapData.index);
                            return snapData.position;
                        },
                        onDragStart: function () {
                            if (ctrl.parentCarousel) {
                                ctrl.parentCarousel.$$draggable[0].disable();
                            }
                            if (ctrl.auto) {
                                $timeout.cancel(ctrl.$$autoRunner);
                            }
                        },
                        onDragEnd: function () {
                            if (ctrl.parentCarousel) {
                                ctrl.parentCarousel.$$draggable[0].enable();
                            }
                        },
                        onThrowComplete: function () {
                            if (ctrl.auto) {
                                ctrl.$$nextAutoStep();
                            }
                        },
                        onThrowUpdate: ctrl.$$updateSlidePositions,
                        onDrag: ctrl.$$updateSlidePositions
                    });
                    if (ctrl.disableDrag) {
                        ctrl.$$draggable[0].disable();
                    }
                }

                $timeout(function () {
                    ctrl.$$slideElements = $element.find('> .loader-wrap > .slides > div > .slide');;
                    ctrl.$$updateSlideReferences(false);
                });
                var updateWidth;
                function getWidth() {
                    $timeout.cancel(ctrl.$$autoRunner);
                    $timeout.cancel(updateWidth);
                    updateWidth = $timeout(function () {
                        ctrl.$$updateSlideReferences();
                        ctrl.$$updateSlidePositions();
                        ctrl.positionDraggable(false);
                        if (ctrl.auto) {
                            ctrl.$$nextAutoStep();
                        }
                    }, 100);
                }

                win = angular.element($window)
                    .on('resize.carousel', getWidth)
                    .on('changed.zf.mediaquery', function () {
                        ctrl.$slideCount = utility.getResponsiveValue(ctrl.slideCount);
                        if (ctrl.$slideCount === undefined) {
                            ctrl.$slideCount = 1;
                        }
                        getWidth();
                    });
                if (ctrl.slides) {
                    getWidth();
                    if (ctrl.auto) {
                        ctrl.$$nextAutoStep();
                    }
                }
            });
        };

        ctrl.$$updateSlideReferences = function (slidesChanged) {
            if (slidesChanged) {
                ctrl.$$slideElements = $element.find('> .loader-wrap > .slides > div > .slide');
            }
            ctrl.maxHeight = 0;
            for (var i = 0; i < ctrl.$$slideElements.length; i++) {
                var slide = angular.element(ctrl.$$slideElements[i]);
                if (ctrl.maxHeight < slide.outerHeight()) {
                    ctrl.maxHeight = slide.outerHeight();
                }
            }
            
            var slideContainerWidth = $element.find('.slides').width();
            ctrl.animationData = ctrl.animationPrep({
                data: {
                    slideElements: ctrl.$$slideElements,
                    slideData: ctrl.slides,
                    carousel: $element,
                    slideContainerWidth: slideContainerWidth,
                    spacing: ctrl.spacing,
                    slideWidth: ctrl.$slideCount && ctrl.slides ? (slideContainerWidth - (ctrl.spacing * (ctrl.$slideCount - 1))) / ctrl.$slideCount : 0
                }
            });
            if (ctrl.preAnimation) {
                ctrl.preAnimation({
                    offset: 0,
                    data: ctrl.animationData
                })
            }
            if (ctrl.animationData) {
                for (i = 0; i < ctrl.$$slideElements.length; i++) {
                    TweenLite.set(
                        ctrl.animationData.slideElements[i],
                        ctrl.animation({
                            offset: 0,
                            direction: 0,
                            index: i,
                            data: ctrl.animationData
                        }));
                }
            }
        };

        ctrl.$$nextAutoStep = function () {
            $timeout.cancel(ctrl.$$autoRunner);
            ctrl.$$autoRunner = $timeout(function () {
                ctrl.scrollWidthRight().then(ctrl.$$nextAutoStep);
            }, ctrl.autoInterval);
        };

        ctrl.handleChildEdgeHit = function (direction) {
            if (direction) {
                ctrl.nextSlide();
            }
            else {
                ctrl.prevSlide();
            }
        };

        ctrl.$onDestroy = function () {
            win.off('resize.carousel');
        };

        ctrl.$$registerTransitions = function () {
            $transitions.onStart({
                to: ctrl.route
            }, function ($transition$, $state, $q) {
                ctrl.targetParams = $transition$.params();
                if (!ctrl.blockTransition) {
                    var deferred = $q.defer();
                    var target = $transition$.params()[ctrl.routeTarget];
                    if (isNaN(target)) {
                        ctrl.$$findIndexByKey(target, 0, deferred);
                    }
                    else {

                        if (ctrl.parentCarousel) {
                            if (angular.equals(ctrl.parentCarousel.slides[ctrl.parentCarousel.index].images, ctrl.slides)) {
                                deferred.resolve(parseInt(target));
                            }
                            else {
                                deferred.reject('Not active sub slide');
                            }
                        }
                        else {
                            deferred.resolve(parseInt(target));
                        }
                    }
                    deferred.promise.then(function (index) {
                        if ($transition$.from().name !== ctrl.route && ctrl.onSlideChange) {
                            ctrl.onSlideChange({
                                index: index,
                                slide: ctrl.slides[index]
                            });
                        }
                        ctrl.goToSlide(index, $transition$.from().name === ctrl.route && (!ctrl.parentCarousel || $transition$.params('from').caseStudy === ctrl.targetParams.caseStudy));
                    });
                    //return deferred.promise;
                }
                ctrl.blockTransition = false;
            });
            if ($state.current.name === ctrl.route) {
                ctrl.targetParams = angular.copy($stateParams);
                var deferred = $q.defer();
                ctrl.indexResolved = deferred.promise;
                var target = $stateParams[ctrl.routeTarget];
                if (isNaN(target)) {
                    ctrl.$$findIndexByKey(target, 0, deferred)
                }
                else {
                    if (ctrl.parentCarousel) {
                        ctrl.parentCarousel.indexResolved.then(function (index) {
                            if (angular.equals(ctrl.parentCarousel.slides[index].images, ctrl.slides)) {
                                deferred.resolve(parseInt(target));
                            }
                            else {
                                deferred.reject('Not active sub slide');
                            }
                        }).catch(function (response) {
                            deferred.reject('Parent carousel failed to determine index');
                        });
                    }
                    else {
                        deferred.resolve(parseInt(target));
                    }
                }
                deferred.promise.then(function (index) {
                    if (ctrl.onSlideChange) {
                        ctrl.onSlideChange({
                            index: index,
                            slide: ctrl.slides[index]
                        });
                    }
                    $timeout(function () {
                        ctrl.goToSlide(index, false);
                    });
                });
            }
        };

        ctrl.$$findIndexByKey = function (target, start, promise) {
            for (var i = start; i < ctrl.slides.length; i++) {
                if (ctrl.slides[i].urlName === target) {
                    promise.resolve(i);
                    return;
                }
            }
            if (ctrl.paginator) {
                if (!ctrl.paginator.paginationPromise.$resolved) {
                    ctrl.paginator.paginationPromise.$promise.then(function () {
                        ctrl.$$findIndexByKey(target, 0, promise);
                    });
                }
                else {
                    ctrl.paginator.nextPage(function () {
                        ctrl.$$findIndexByKey(target, i, promise);
                    });
                }
            }
            else {
                promise.reject('Key not found');
            }
        };

        ctrl.$$updateSlidePositions = function () {
            var xShift = ctrl.$$dragger._gsTransform.x;
            if (ctrl.$previousOffset === undefined) {
                ctrl.$previousOffset = xShift;
            }
            var dir = xShift - ctrl.$previousOffset;
            if (dir) {
                dir = dir / Math.abs(dir);
            }
            if (ctrl.preAnimation) {
                ctrl.preAnimation({
                    offset: xShift,
                    data: ctrl.animationData
                })
            }
            if (ctrl.slides && ctrl.animationData) {
                for (var i = 0; i < ctrl.slides.length; i++) {
                    TweenLite.set(
                        ctrl.animationData.slideElements[i],
                        ctrl.animation({
                            offset: xShift,
                            direction: dir,
                            index: i,
                            data: ctrl.animationData
                        }));
                }
            }
            ctrl.$previousOffset = xShift;
            $scope.$broadcast('carouselV2.updated', {
                offset: xShift,
                direction: dir
            });
        };

        ctrl.$$updateIndex = function (index, synced) {
            if (ctrl.onEdge) {
                if (index >= ctrl.slides.length) {
                    ctrl.onEdge({
                        direction: 1
                    });
                }
                else if (index < 0) {
                    ctrl.onEdge({
                        direction: 0
                    });
                }
            }
            newIndex = index >= 0 ? index % ctrl.slides.length : ctrl.slides.length - 1 + ((index + 1) % ctrl.slides.length);
            if (ctrl.index !== newIndex) {
                var forward, backward;
                if (newIndex > ctrl.index) {
                    forward = newIndex - ctrl.index;
                    backward = ctrl.index + (ctrl.slides.length - newIndex);
                }
                else {
                    forward = newIndex + (ctrl.slides.length - ctrl.index);
                    backward = ctrl.index - newIndex;
                }
                if (forward <= backward) {
                    ctrl.renderIndex += forward;
                }
                else {
                    ctrl.renderIndex -= backward;
                }
                ctrl.index = newIndex;
                if (!synced) {
                    if (ctrl.carouselSync) {
                        ctrl.carouselSync.updateCarousels(newIndex, ctrl.carouselIndex);
                    }
                    if (ctrl.onSlideChange) {
                        ctrl.onSlideChange({
                            index: newIndex,
                            slide: ctrl.slides[index],
                            ctrl: ctrl
                        });
                    }
                    
                    $scope.$broadcast('slideChange', {
                        index: index
                    });
                }
            }
        };

        ctrl.updateSlides = function (data) {
            ctrl.nextDisabled = data.rows - 1 > ctrl.index;
        };

        ctrl.scrollWidthLeft = function () {
            return ctrl.$$scrollWidth(1);
        };

        ctrl.scrollWidthRight = function () {
            return ctrl.$$scrollWidth(-1);
        };

        ctrl.$$scrollWidth = function (dir) {
            var deferred = $q.defer();
            if (!ctrl.$$dragDisabled)
                ctrl.$$draggable[0].disable();
            var snap = ctrl.animationSnap({ offset: ctrl.$$dragger._gsTransform.x + (dir * ctrl.animationData.slideContainerWidth), data: ctrl.animationData });
            ctrl.$$updateIndex(snap.index);
            TweenLite.to(ctrl.$$dragger, .8, {
                throwProps: {
                    x: {
                        velocity: 'auto',
                        end: snap.position
                    }
                },
                onUpdate: ctrl.$$updateSlidePositions,
                onComplete: function () {
                    if (!ctrl.$$dragDisabled) {
                        ctrl.$$draggable[0].update();
                        if (!ctrl.disableDrag) {
                            ctrl.$$draggable[0].enable();
                        }
                    }
                    deferred.resolve();
                }
            });
            return deferred.promise;
        };

        ctrl.goToSlide = function (index, animate, synced) {
            ctrl.$$updateIndex(index, synced);
            var animationComplete = ctrl.positionDraggable(animate);
            if (ctrl.index >= 0 && ctrl.index < ctrl.slides.length) {
                ctrl.prevDisabled = ctrl.index === 0;
                ctrl.nextDisabled = ctrl.index >= ctrl.slides.rows - 1;
            }
            return animationComplete;
        };

        ctrl.prevSlide = function () {
            if (ctrl.index === 0 && ctrl.onEdge) {
                ctrl.onEdge({
                    direction: 0
                });
            }
            else {
                ctrl.goToSlide(ctrl.index - 1, true);
            }
        };

        ctrl.nextSlide = function () {
            if (ctrl.index === ctrl.slides.length - 1 && ctrl.onEdge) {
                ctrl.onEdge({
                    direction: 1
                });
            }
            else {
                ctrl.goToSlide(ctrl.index + 1, true);
            }
        };

        ctrl.positionDraggable = function (animate) {
            var deferred = $q.defer();
            var target = ctrl.animation({
                offset: ctrl.$$dragger._gsTransform.x,
                index: ctrl.index,
                data: ctrl.animationData
            });
            var targetShift = target.offsetShift;
            if (targetShift === undefined) {
                targetShift = target.x;
            }
            if (animate) {
                if (!ctrl.$$dragDisabled)
                    ctrl.$$draggable[0].disable();
                TweenLite.to(ctrl.$$dragger, .8, {
                    throwProps: {
                        x: {
                            velocity: 'auto',
                            end: ctrl.$$dragger._gsTransform.x - targetShift
                        }
                    },
                    onComplete: function () {
                        if (!ctrl.$$dragDisabled) {
                            ctrl.$$draggable[0].update();
                            if (!ctrl.disableDrag) {
                                ctrl.$$draggable[0].enable();
                            }
                        }
                        deferred.resolve();
                    },
                    onUpdate: ctrl.$$updateSlidePositions
                });
            }
            else if (target) {
                TweenLite.set(ctrl.$$dragger, {
                    x: ctrl.$$dragger._gsTransform.x - targetShift
                });
                if (!ctrl.$$dragDisabled) {
                    ctrl.$$draggable[0].update();
                }
                ctrl.$$updateSlidePositions();
                deferred.resolve();
            }
            return deferred.promise;
        };
    }
})();